export default "/images/Open_Hover.svg?037603924fa2a1fef1e2c12d653dbe07";